<div *ngIf="data[header.field].includes(',')" class="info-icon cursor-pointer" (mouseenter)="data.showSkus = true"
    (mouseleave)="data.showSkus = false" (mouseleave)="remove()">
    {{ data[header.field] | slice : 0 : 15 }}
    <a class="underlined-link" (click)="SKUs(data)">
        "show more"
    </a>
    <div class="skus-bubble sku-left" *ngIf="data.showSkus &&unavailableData && unavailableData?.length !== 0">
        <ol>
            <li *ngFor="let item of unavailableData">{{ item }}</li>
        </ol>
    </div>
</div>
<div *ngIf="!data[header.field].includes(',')">
    {{ data[header.field] }}
</div>